// =====================================================
// PRICING RULE HELPERS
// Stage 2: Participants & Pricing
// Fetchers for the dropdown data used by pricing conditions
// =====================================================

import { getDegreesList } from '@/data/ministerRepository';
import { getAllDistricts, getAllRegions } from '@/Services/regions.service';
import type { Degree } from '@/models/degree';
import type { District } from '@/models/district';
import type { Region } from '@/models/region';

// ===================
// DATA FETCHERS
// ===================

/**
 * Get list of degrees from database
 */
export async function fetchDegrees(): Promise<Degree[]> {
  try {
    return await getDegreesList();
  } catch (error) {
    console.error('Error fetching degrees:', error);
    return [];
  }
}

/**
 * Get list of districts from database
 */
export async function fetchDistricts(): Promise<District[]> {
  try {
    return await getAllDistricts();
  } catch (error) {
    console.error('Error fetching districts:', error);
    return [];
  }
}

/**
 * Get list of regions from database
 */
export async function fetchRegions(): Promise<Region[]> {
  try {
    return await getAllRegions();
  } catch (error) {
    console.error('Error fetching regions:', error);
    return [];
  }
}
